import { EventFormQuestion } from "@ac-expo/api-types";
import { Control } from "react-hook-form";
import { CreateEventFormAnswersForm } from "@ac-expo/api";
import { FormTextarea } from "../form/FormTextarea";
import { Textarea } from "../Textarea";
import { Label } from "../Label";

interface EventFormLongTextProps {
  question: EventFormQuestion;
  control?: Control<CreateEventFormAnswersForm>;
  index?: number;
  isReadOnly?: boolean;
}

export default function EventFormLongText({
  question,
  control,
  index,
  isReadOnly = false,
}: EventFormLongTextProps) {
  if (isReadOnly) {
    return (
      <div className="space-y-2">
        <Label className="text-sm text-gray-600">
          {question.theme} : {question.question}
        </Label>
        <Textarea
          placeholder="Votre réponse..."
          className="bg-gray-50"
          rows={4}
        />
      </div>
    );
  }

  if (!control || index === undefined) {
    throw new Error(
      "control and index are required when not in read-only mode"
    );
  }

  return (
    <FormTextarea
      key={question.id}
      control={control}
      name={`answers.${index}.answer`}
      className="bg-white"
      label={`${question.theme} : ${question.question}`}
      placeholder="Votre réponse..."
      hasMessage
      maxLength={256}
    />
  );
}
